import { render, staticRenderFns } from "./OrdersDetail.vue?vue&type=template&id=7d9a822e&lang=html&"
import script from "./OrdersDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports